
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'

export default {
components: {
Cell,
Group
}
}



// WEBPACK FOOTER //
// ./src/components/UseHelper.vue